// extracted by mini-css-extract-plugin
export var aiStarIcon = "_cy-4";
export var closeButton = "_cy-6";
export var dismissButton = "_cy-3";
export var editImageWithAiContainer = "_cy-8";
export var imageUploadWrapper = "_cy-7";
export var misspelledWord = "_cy-5";
export var spellCheckContainer = "_cy-2";
export var spin = "_cy-1";
export var spinning = "_cy-0";